import { styled, Typography } from '@ori-ui/mui';
import { StaticNavigationNavigationItemDtoLinkType } from '@ori/static-api-client-react';
import parser from 'html-react-parser';
import React from 'react';
import sanitizeHtml from 'sanitize-html';

import { maxTextWidth } from '../../constants';
import { useFooterContext } from '../../hooks';
import { extractFooterNavigationType, extractChildrenWithNavigationType } from '../../utils';
import { ContentRoot } from './ContentRoot';

const Content = styled(Typography)(() => ({
  display: 'block',
  margin: '0 auto',
  maxWidth: maxTextWidth,
}));

// it is footer and we are restrictive with what is allowed
const sanitizeOptions: sanitizeHtml.IOptions = {
  allowedTags: ['a', 'b', 'br', 'div', 'em', 'i', 'img', 'p', 's', 'span', 'strong', 'sub', 'sup'],
  disallowedTagsMode: 'discard',
  allowedAttributes: {
    a: ['href', 'name', 'target', 'rel'],
    img: ['src', 'srcset', 'alt', 'title', 'width', 'height'],
    '*': ['class', 'style', 'data-*', 'aria-*'],
  },
  selfClosing: ['img', 'br'],
  allowedSchemes: ['http', 'https'],
  allowedSchemesByTag: { img: ['data', 'http', 'https'] },
  allowedSchemesAppliedToAttributes: ['href', 'src'],
  allowProtocolRelative: true,
  enforceHtmlBoundary: false,
};

export const ContentAllPages: React.FC = () => {
  const { data } = useFooterContext();

  const footer = extractFooterNavigationType(data);
  const bottom = extractChildrenWithNavigationType(StaticNavigationNavigationItemDtoLinkType.Bottom, footer);

  const description = bottom?.description ?? undefined;
  const isVisible = typeof description !== 'undefined';

  return isVisible ? (
    <ContentRoot>
      <Content variant="caption">{parser(sanitizeHtml(description, sanitizeOptions))}</Content>
    </ContentRoot>
  ) : null;
};
